import React from "react";

const Admindashboard = () => {
  return <div>Admindashboard</div>;
};

export default Admindashboard;
